import { render, staticRenderFns } from "./TOOL_DATA_RECOVERY.vue?vue&type=template&id=221b643a&scoped=true"
import script from "./TOOL_DATA_RECOVERY.vue?vue&type=script&lang=ts"
export * from "./TOOL_DATA_RECOVERY.vue?vue&type=script&lang=ts"
import style0 from "./TOOL_DATA_RECOVERY.vue?vue&type=style&index=0&id=221b643a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221b643a",
  null
  
)

export default component.exports